import { Button } from '@mui/material'

import { RemoveButtonContainer } from './styles'

interface Props {
	label: string
	onClick: () => void
}

const RemoveButton: React.FC<Props> = ({ label, onClick }) => (
	<RemoveButtonContainer>
		<Button variant="text" onClick={onClick} size="large">
			{label}
		</Button>
	</RemoveButtonContainer>
)

export { RemoveButton }
